import { useNavigate } from "react-router-dom";
import PageHeader from "@/components/PageHeader";
import AiGalleryGrid from "@/components/AiGalleryGrid";

export default function Gallery() {
  const navigate = useNavigate();
  return (
    <div>
      <PageHeader eyebrow="Galeri AI" title="Gambar AI anda" desc="Semua gambar yang pernah dijana AI. Guna semula dalam post baharu, muat turun, atau padam yang tidak diperlukan." />
      <AiGalleryGrid allowDelete pickLabel="Guna dalam post" onPick={(it) => navigate("/tulis", { state: { imageId: it.id, imageTitle: it.title } })} />
    </div>
  );
}
